// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../.config/yarn/global/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora&display=swap);"]);
// Module
exports.push([module.id, "* {\n  font-family: 'Sora', sans-serif;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
